// extracted by mini-css-extract-plugin
module.exports = {"person":"MediaPeopleLinks_person__cDgzg","icon":"MediaPeopleLinks_icon__8TIKI"};